import '../Building/BuildingMenu/BuildingMenu';
import '../Building/BuildingSubscribe/BuildingSubscribe';
import '../DeveloperQuestionPopup/DeveloperQuestionPopup';
import { replaceUrl } from '../helpers/query-string';
import ConstructionMap from './ConstructionMap/ConstructionMap';
import ConstructionTabs from './ConstructionTabs/ConstructionTabs';
import ConstructionGallery from './ConstructionGallery/ConstructionGallery';
import ConstructionQueues from './ConstructionQueues/ConstructionQueues';
import './Construction.scss';
import '../Subscribe/Subscribe';

class Construction {
  constructor() {
    this.sourceData = window.params.houses;
    this.houseIndex = window.params.houseIndex;
    this.parent = document.getElementById('construction');

    this.onTabUpdate = this.onTabUpdate.bind(this);

    this.init();
  }

  init() {
    this.tabs = new ConstructionTabs(this.parent, this.onTabUpdate);
    this.queues = new ConstructionQueues(this.parent);
    this.map = new ConstructionMap(this.parent, this.sourceData, this.houseIndex);
    this.gallery = new ConstructionGallery(this.parent, this.sourceData, this.houseIndex);
    this.map.updateMaxHeight(this.gallery.currentHouseNode);
  }

  setHouseIndex(newIndex) {
    this.houseIndex = Number(newIndex);
  }

  onTabUpdate(newIndex, houseId) {
    this.setHouseIndex(newIndex);
    this.queues.update(this.houseIndex);
    this.gallery.update(this.houseIndex);
    this.map.updateMaxHeight(this.gallery.currentHouseNode);
    this.map.selectSections(this.houseIndex);
    // eslint-disable-next-line camelcase
    replaceUrl({ params: { houseId } });
  }
}

new Construction();
